<template>
  <div class="contact-us-page">
    <ContactUsScreen
      :title="pageContent.title"
      :subtitle="pageContent.subtitle"
      :description="pageContent.description"
    />
  </div>
</template>

<script setup>
  import ContactUsScreen from "~/components/page-screens/ContactUsScreen.vue";

  const route = useRoute();

  const { getCurrentPageSettings } = useWebsiteContent();
  const { data: pageSettings, suspense: pageSettingsSuspense } =
    getCurrentPageSettings();
  await pageSettingsSuspense();

  const pageContent = computed(() => ({
    title: pageSettings.value.additional?.contactUsScreen?.title,
    subtitle: pageSettings.value.additional?.contactUsScreen?.subtitle,
    description: pageSettings.value.additional?.contactUsScreen?.description,
  }));

  definePageMeta({
    settings: {
      cover: {
        title: "Contact Us",
      },
    },
  });
</script>

<style lang="scss">
  .contact-us-page {
  }
</style>
